import { LocationIntegrationContract } from 'models'
import { IntegrationContract } from 'models/IntegrationContract'
import {
    addIntegrationActions,
    deleteIntegrationActions,
    getAllIntegrationsActions,
    getIntegrationActions,
    INTEGRATION_RESET_FORM,
    updateIntegrationActions,
} from 'store/actions/integration.action'

interface IAction {
    type: string
    payload: any
}

interface IIntegrationState {
    // Main
    loading: boolean
    integrations: IntegrationContract[]
    locationIntegrations: LocationIntegrationContract[]

    // Edit
    integration?: IntegrationContract
    editIntegration?: LocationIntegrationContract
    editLoading: boolean
    editCompleted: boolean
    submitting: boolean
}

const initialState: IIntegrationState = {
    editLoading: false,
    editCompleted: false,
    submitting: false,
    integrations: [],
    locationIntegrations: [],
    integration: undefined,
    loading: false,
    editIntegration: undefined,
}

function integrationReducer(
    state: IIntegrationState = initialState,
    action: IAction,
): IIntegrationState {
    const { type } = action
    switch (type) {
        case getAllIntegrationsActions.onPending:
            return {
                ...state,
                loading: true,
            }
        case getAllIntegrationsActions.onSuccess:
            return {
                ...state,
                integrations: action.payload.integrations,
                locationIntegrations: action.payload.locationIntegrations,
                loading: false,
            }
        case getAllIntegrationsActions.onFailed:
            return {
                ...state,
                loading: false,
            }
        case getIntegrationActions.onPending:
            return {
                ...state,
                editLoading: true,
            }
        case getIntegrationActions.onSuccess:
            return {
                ...state,
                integration: action.payload.metadata,
                editIntegration: action.payload.integration,
                editLoading: false,
            }
        case getIntegrationActions.onFailed:
            return {
                ...state,
                editLoading: false,
            }
        case addIntegrationActions.onPending:
            return {
                ...state,
                submitting: true,
            }
        case addIntegrationActions.onSuccess:
            return {
                ...state,
                editCompleted: true,
                submitting: false,
            }
        case addIntegrationActions.onFailed:
            return {
                ...state,
                submitting: false,
            }
        case updateIntegrationActions.onPending:
            return {
                ...state,
                submitting: true,
            }
        case updateIntegrationActions.onSuccess:
            return {
                ...state,
                editCompleted: true,
                submitting: false,
            }
        case updateIntegrationActions.onFailed:
            return {
                ...state,
                submitting: false,
            }
        case deleteIntegrationActions.onPending:
            return {
                ...state,
                submitting: true,
            }
        case deleteIntegrationActions.onSuccess:
            return {
                ...state,
                editCompleted: true,
                submitting: false,
            }
        case deleteIntegrationActions.onFailed:
            return {
                ...state,
                submitting: false,
            }
        case INTEGRATION_RESET_FORM:
            return {
                ...state,
                editCompleted: false,
            }
        default:
            return state
    }
}

export default integrationReducer
